import { Timeline } from 'react-twitter-widgets';
import React from "react";
import { height } from 'window-size';

export class EmbeddedTwitter extends React.Component {

    render() {
        return (
            <Timeline
                dataSource={{
                    sourceType: 'profile',
                    screenName: 'HRRP_Nepal'
                }}
                options={{
                    username: 'HRRP_Nepal',
                    width: '400',
                    height: "400"
                }}
                onLoad={() => ''}
            />
        );
    }
}
